import Api from './Api.service';

export default class DocenteService {

    static ObtenerTodo() {
        return Api.get('docente');
    }
    static Insertar(model) {
         return Api.post('docente/insertar',model);
    }
    static Editar(model) {
         return Api.put('docente/editar',model);
    }
    static Eliminar(docenteId) {
         return Api.delete(`docente/editar/${docenteId}`);
    }
}